var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M740.68 800a35 35 0 0 0-49.5 49.5l92.92 92.92a35 35 0 0 0 49.5 0l290.7-290.7a35 35 0 0 0-49.5-49.5l-266 266z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.22 1081.55A256.78 256.78 0 0 0 1073 824.78c0-5.47-.17-11-.52-16.46a35 35 0 0 0-69.86 4.43c.25 4 .38 8 .38 12 0 103-83.79 186.78-186.78 186.78s-186.77-83.77-186.77-186.75S713.23 638 816.22 638a184.63 184.63 0 0 1 117.67 41.72A35 35 0 0 0 978 625.38a256.78 256.78 0 1 0-161.8 456.17z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.1 1006.56h210.23a35 35 0 1 0 0-70H333.1a56.71 56.71 0 0 1-56.65-56.65v-326.6h674.64a35 35 0 0 0 70-1.64v-157.6A126.79 126.79 0 0 0 894.4 267.42h-83.47v-39a35 35 0 1 0-70 0v39H493.75v-39a35 35 0 0 0-70 0v39H333.1a126.79 126.79 0 0 0-126.65 126.65v485.84a126.79 126.79 0 0 0 126.65 126.65zm-56.65-612.49a56.71 56.71 0 0 1 56.65-56.65h561.3a56.71 56.71 0 0 1 56.6 56.65v99.23H276.45z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBooking);
export default __webpack_public_path__ + "static/media/add-booking.28668e2a7470d5ed53461cd5a49e93fb.svg";
export { ForwardRef as ReactComponent };